/**
 * @description: 门牌机自定义设置
 * @author: lyr
*/
<template>
    <div class="door-plate-set">
        <div class="list" v-show="!showDetail">
            <h1>门牌机自定义设置</h1>
            <div class="red-tip">商家可自定义门牌机背景及显示内容</div>
            <el-table
                class="list-table"
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :header-cell-style="{'text-align':'center'}"
    			:cell-style="{'text-align':'center'}"
                :data="list_table">
                <el-table-column prop="shop_name" label="门店"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <span class="text-blue" @click="onSetClick(scope.row)">设置</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :page-size="GLOBAL.PAGESIZE"
                :current-page.sync="list_page"
                :total="list_total"
                @current-change="getList">
            </el-pagination>
        </div>

        <!-- 设置详情 -->
        <div class="detail" v-show="showDetail">
        	<div class="shop-name">门店：{{set_form.shop_name}}</div>
    		<el-form label-position="left" label-width="210px">
    			<div class="gray-block">
					<el-form-item label="门牌及背景图设置">
						<el-radio v-model="set_form.background_img_setting" label="1">默认</el-radio>
  						<el-radio v-model="set_form.background_img_setting" label="2">自定义</el-radio>
					</el-form-item>
					<div class="img-wrapper" v-show="set_form.background_img_setting=='2'">
						<div class="item" v-if="!!set_form.background_img.screen">
							<img :src="set_form.background_img.screen" id="bg-img" class="bg-img">
							<div class="tip">全屏背景图</div>
						</div>
						<div class="item" v-else>
							<img src="../../assets/images/set/bg.png" id="bg-img" class="bg-img">
							<div class="tip">全屏背景图</div>
						</div>
						<div class="item" v-if="!!set_form.background_img.room_status">
							<img :src="set_form.background_img.room_status" id="status-img" class="status-img">
							<div class="tip">房态背景图</div>
						</div>
						<div class="item" v-else>
							<img src="../../assets/images/set/room_status_bg.png" id="status-img" class="status-img">
							<div class="tip">房态背景图</div>
						</div>
						<div class="item" v-if="!!set_form.background_img.button">
							<img :src="set_form.background_img.button" id="fun-img" class="fun-img">
							<div class="tip">功能键背景图</div>
						</div>
						<div class="item" v-else>
							<img src="../../assets/images/set/fun_btn_bg.png" id="fun-img" class="fun-img">
							<div class="tip">功能键背景图</div>
						</div>
					</div>	
    			</div>
    			<div class="gray-block">
    				<el-form-item label="门店logo图片设置"></el-form-item>
					<div class="img-wrapper">
						<img :src="set_form.shop_logo" id="logo-img" class="logo-img" v-if="!!set_form.shop_logo">
						<img src="../../assets/images/set/shop_logo.png" id="logo-img" class="logo-img" v-else>
					</div>
    			</div>
    			<div class="gray-block">
    				<el-form-item label="包厢名称色调设置" class="single-line">
						<el-radio v-model="set_form.room_name_font_color_setting" label="1">默认</el-radio>
  						<el-radio v-model="set_form.room_name_font_color_setting" label="2">自定义</el-radio>
  						<div class="color-wrapper" v-if="set_form.room_name_font_color_setting=='2'">
  							<div class="color" :style="roomNameColor"></div>
  							<el-input class="color-num" v-model="set_form.room_name_font_color" maxlength="6" minlength="3">
								<template slot="prepend">#</template>
  							</el-input>	
  						</div>
    				</el-form-item>
    			</div>
    			<div class="gray-block">
    				<el-form-item label="内容区显示设置"></el-form-item>
    				<el-form-item :label="'内容区轮播图片设置（' + set_form.content_img.length + '/10）'"></el-form-item>
    				<div class="content-img-wrapper">
    					<div class="item" v-for="(item, index) in set_form.content_img">
    						<img :src="item" class="content-img" :id="'content-img-'+index">
    						<img src="../../assets/images/scrn_del.png" alt="" class="del-icon" @click="deleteThisImg(index)">
    					</div>
    					<div class="item" v-if="set_form.content_img.length<10">
    						<img src="../../assets/images/set/content_bg.png" class="content-img" id="add-content-img">
    					</div>
    				</div>
    				<el-form-item label="内容区图片轮播间隔">
						<el-input class="interval-input" v-model="set_form.content_img_interval">
							<template slot="append">秒</template>
						</el-input>
    				</el-form-item>
    				<el-form-item label="内容区是否显示预定信息">
						<el-radio v-model="set_form.show_book_info" label="-1">否</el-radio>
  						<el-radio v-model="set_form.show_book_info" label="1" @change="onShowBookInfoConfirm">是<span class="red-tip">（设置后，包厢有预定记录时，预定、开房、结账房态下内容区优先显示预定客户信息）</span></el-radio>
    				</el-form-item>
    				<el-form-item label="" v-if="set_form.show_book_info=='1'">
    					<el-checkbox-group v-model="set_form.book_info_fields">
							<el-checkbox v-for="item in book_info_arr" :label="item.value">{{item.name}}</el-checkbox>
    					</el-checkbox-group>
    				</el-form-item>
    			</div>
    			<div class="gray-block">
    				<el-form-item label="操作区功能按键显示">
						<el-checkbox v-model="chooseAllFlag" @change="onChooseAllButtonClick">全选</el-checkbox>
    				</el-form-item>
    				<el-form-item label="">
	    				<el-checkbox-group v-model="set_form.buttons">
							<el-checkbox v-for="item in buttons_arr" :label="item.value"  @change="onChooseButtonClick">{{item.name}}</el-checkbox>
						</el-checkbox-group>
    				</el-form-item>
    			</div>
    			<el-form-item>
	                <el-button @click="backtoList">返回</el-button>
	                <el-button type="primary" @click="commit">确定</el-button>
	            </el-form-item>
        	</el-form>
        </div>
    </div> 
</template>
<script>
    import Vue from 'vue';
    export default {
        name: 'door_plate_set',
        data() {
            return {
                loading: false,
                list_table: [],
                list_page: 1,
                list_total: 0,
                page_size: 10,
                showDetail: false,

                book_info_arr: [{
                	value:'customer_name', 
                	name: '预定客户'
                }, {
                	value: 'customer_mobile', 
                	name: '客户手机号'
                }, {
                	value: 'book_time',
                	name: '到店时间'
                }, {
                	value: 'waiter',
                	name: '服务生'
                }, {
                	value: 'book_admin_name',
                	name: '订台员工'
                }],
                buttons_arr: [{
                	value: 'supermarket',
                	name: '商品点单'
                }, {
                	value: 'bill',
                	name: '账单查看'
                }, {
                	value: 'service',
                	name: '服务'
                }, {
                	value: 'setting',
                	name: '设置'
                }],
                chooseAllFlag: false,
                uploader_list: [],
                set_form: {
                	doorplate_id: '',
                	shop_name: '',
                	shop_id: '',
                	background_img_setting: '1', // 自定义背景图，1：默认，2：自定义
                	background_img: { // 自定义背景图
                		screen: '',
                		room_status: '',
                		button: ''
                	},
                	shop_logo: '',
                	room_name_font_color_setting: '1', // 包厢字体颜色，1：默认，2：自定义
                	room_name_font_color: '',
                	content_img: [],
                	content_img_interval: '',
                	show_book_info: '-1', // 是否显示预定信息，-1：否，1：是
                	book_info_fields: ['customer_name', 'customer_mobile', 'book_time', 'waiter', 'book_admin_name'],
                	buttons: [ "supermarket", "bill",  "service", "setting"]
		        }
            }
        },
        watch: {
        },
        computed: {
        	roomNameColor() {
        		return 'background-color:#' + this.set_form.room_name_font_color
        	},
        },
        mounted: function() {
            this.getList(this.list_page)
        },
        methods: {
        	// 列表
			getList: function(page) {
				const _this = this;
				_this.loading = true;
				Vue.axios.post('Doorplate/getList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
                            "page_size": _this.page_size,
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
                            _this.list_total = Number(res.data.response.result.count)
						}
						_this.list_table = res.data.response.result.data;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },

            // 点击“设置”
            onSetClick: function (row) {
            	this.set_form = row
            	if (this.set_form.buttons.length == this.buttons_arr.length) {
            		this.chooseAllFlag = true
            	}else {
            		this.chooseAllFlag = false
            	}
            	this.showDetail = true

            	this._destroyUploader()
            	this.$nextTick(() => {
            		this.initUpload('bg-img')
            		this.initUpload('status-img')
            		this.initUpload('fun-img')
            		this.initUpload('logo-img')
            		if(this.set_form.content_img.length > 0) {
            			this.set_form.content_img.forEach((item, index) => {
            				this.initUpload(`content-img-${index}`, index)
            			})
            		}
            		this.initUpload('add-content-img')
            	})
            },

            // 点击“返回”
            backtoList: function() {
            	this.showDetail = false
            },

            // 点击“全选”
            onChooseAllButtonClick: function(val) {
            	if (val) {
            		this.set_form.buttons = []
            		this.buttons_arr.forEach(v => {
            			this.set_form.buttons.push(v.value)
            		})
            	}else {
            		this.set_form.buttons = []
            	}
            },

            onChooseButtonClick: function(val) {
            	if (this.set_form.buttons.length == this.buttons_arr.length) {
            		this.chooseAllFlag = true
            	}else {
            		this.chooseAllFlag = false
            	}
            },

            // 初始化上传图片
			initUpload: function(btnName, index) {
				let _this = this;
				let host = '',
					dir = '',
					file_name = '';

				setTimeout(function() {
					// 实例化一个plupload上传对象
					let uploader = new plupload.Uploader({
						browse_button: btnName, // 选择文件id
						filters: {
							mime_types: [ // 文件格式限制
								{ title: "Image files", extensions: 'jpg,jpeg,png,gif' }
							],
							// max_file_size: '2mb', // 文件大小限制
							// prevent_duplicates: true // 不允许选取重复文件
						},
						// resize: {
						// 	width: 527,
						// 	height: 296
						// },
						multi_selection: false, // 单选
						url: './', // OSS地址
						init: {
							// 文件上传前触发
							BeforeUpload: function(up, file) {},
							// 文件选择完毕触发
							FilesAdded: function(up, files) {
								// 获取签名
								Vue.axios.post('publicData/api_getOssSignature', {
									"header": Vue.request_header,
									"request": {
										"version": Vue.version,
										"param": {
											"file": files[0].name,
											"path": 'system_set'
										}
									},
									"comment": ""
								})
								.then(res => {
									if(res.data.response.result_code == "true") {
										host = res.data.response.data.host;
										dir = res.data.response.data.dir;
										file_name = res.data.response.data.file_name;
										const new_params = {
											'key': dir + file_name,
											'OSSAccessKeyId': res.data.response.data.accessid,
											'policy': res.data.response.data.policy,
											'signature': res.data.response.data.signature,
											'success_action_status': '200', // 让服务端返回200，不然，默认会返回204
										};
										up.setOption({
											'url': host,
											'multipart_params': new_params
										});

										// 上传文件
										uploader.start();
									} else {
										Vue.timeoutfun(data.response.result_status, _this);
										layer.msg(data.response.error_msg);
									}
								})
								.catch(err => {
									layer.msg("出错啦");
								});
							},
							// 文件上传成功触发
							FileUploaded: function(up, file, data) {
                                let file_url = host + "/" + dir + file_name
                                console.log("文件上传成功：", file_url)
                                if (btnName.indexOf("bg-img") > -1) {
                                	_this.set_form.background_img.screen = file_url
                                }else if (btnName.indexOf("status-img") > -1) {
                                	_this.set_form.background_img.room_status = file_url
                                }else if (btnName.indexOf("fun-img") > -1) {
                                	_this.set_form.background_img.button = file_url
                                }else if (btnName.indexOf("logo-img") > -1) {
                                	_this.set_form.shop_logo = file_url
                                }else if(btnName.indexOf("content-img-") > -1) {
                                	_this.set_form.content_img[index] = file_url
                                	_this.$forceUpdate()
                                }else if(btnName.indexOf("add-content-img") > -1) {
                                	_this.set_form.content_img.push(file_url)
                                }
							},
							// 错误提示
							Error: function(up, err) {
								if(err.code == -600) {
									layer.msg('请选择2mb以内的文件');
								} else if (err.code == -601) {
									layer.msg('只允许上传'+ allow_type +'文件');
								} else if (err.code == -602) {
									layer.msg('这个文件已经上传过一遍了');
								} else {
									layer.msg(err.response);
								}
							},
							// 初始化完成触发
							PostInit: function () {
								_this.uploader_list.push(uploader)
							}
						}
					});
					// 初始化
					uploader.init();
				}, 20);
            },

            _destroyUploader: function () {
            	if (this.uploader_list.length > 0) {
	        		this.uploader_list.forEach(v => {
	        			v.destroy()
	        		})
        			this.uploader_list = []
            	}
            },

            // (多图轮播）删除图片
            deleteThisImg: function (index) {
            	this.set_form.content_img.splice(index, 1)
            },

            // 选择显示预定信息
            onShowBookInfoConfirm: function (val) {
            	if (val) {
            		this.set_form.book_info_fields = ['customer_name', 'customer_mobile', 'book_time', 'waiter', 'book_admin_name']
            	}
            },

            // 确定提交
            commit: function() {
            	let _this = this
            	Vue.axios.post('Doorplate/setting', {
					"header": Vue.request_header,
					"request": {
						"param": _this.set_form
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						layer.msg("操作成功")
						_this.getList(_this.list_page)
						_this.showDetail = false
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },
        }
    }
</script>
<style lang="less" scoped>
	.red-tip {
		color: red;
	}
	.list-table {
		margin-top: 10px;
	}
	.detail {
		.shop-name {
			font-size: 18px;
			padding: 20px;
		}
		.gray-block {
			width: 90%;
			margin-bottom: 30px;
			margin-left: 10px;
			padding: 10px 15px;
			background: rgb(242,242,242);
			.el-form-item {
				margin-bottom: 10px;
			}
			.img-wrapper {
				display: flex;
				flex-direction: row;
				align-items: center;
				.item {
					position: relative;
					height: 230px;
					margin-right: 50px;
					margin-left: 20px;
					padding-bottom: 30px;
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: center;
					.bg-img {
						width: 150px;
						height: 200px;
					}
					.status-img,
					.fun-img {
						width: 180px;
						height: 90px;
					}
					.tip {
						position: absolute;
						bottom: 0;
					}
				}
				.logo-img {
					width: 260px;
					height: 145px;
					margin: 0 0 15px 20px;
				}
			}
			.single-line {
				position: relative;
			}
			.color-wrapper {
				position: absolute;
			    left: 200px;
			    bottom: -3px;
				display: flex;
				flex-direction: row;
				align-items: center;
				.color {
					width: 20px;
					height: 20px;
					border: 1px solid #ccc;
					margin-right: 10px;
				}
				.color-num {
					width: 150px;
				}
			}
			.content-img-wrapper {
				display: flex;
				flex-direction: row;
				align-items: center;
				flex-wrap: wrap;
				.item {
					position: relative;
					margin-left: 20px;
					margin-bottom: 20px;
					margin-right: 20px;
					.content-img {
						width: 172px;
						height: 154px;
					}
					.del-icon {
						position: absolute;
						z-index: 2;
						top: -10px;
						right: -10px;
						width: 24px;
					}
				}
			}
			.interval-input {
				width: 200px;
			}
		}
	}
</style>